import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuserviceService {

  private menuSubject = new BehaviorSubject<any[]>([]);

  menu$ = this.menuSubject.asObservable();

  constructor() { }

  setMenu(data: any[]) {
    this.menuSubject.next(data);
     localStorage.setItem('menudata', JSON.stringify(data));
  }

  getMenus() {
  if (this.menuSubject.value.length > 0) {
    return this.menuSubject.value;
  }

  const menu = localStorage.getItem('menudata');

  if (menu) {
    const menuData = JSON.parse(menu);
    this.menuSubject.next(menuData);
    return menuData;
  }

  return [];
}

  getMenuDetails(page: string): any {

    var item = this.findMenu(this.getMenus(), page);

    if (item) {
      return item;
    }

    return null;
  }

  private findMenu(menu: any[], page: string): any {

    for (let i = 0; i < menu.length; i++) {

      if (menu[i].page === page) {
        return menu[i];
      }

      if (menu[i].submenu && menu[i].submenu.length > 0) {

        var found = this.findMenu(menu[i].submenu, page);

        if (found) {
          return found;
        }
      }
    }

    return null;
  }
}